import API from "../../../../../global/api";


export const requestFlavorsData = () => {
  return {
    type: "REQUEST_FLAVORS_GET_DATA",
  };
};
export const successFlavorsGetData = (data) => {
  return {
    type: "SUCCESS_FLAVORS_GET_DATA",
    payload: data,
  };
};
export const errorFlavorsGetData = () => {
  return {
    type: "ERROR_FLAVORS_GET_DATA",
  };
};
export const getFlavorsData = () => {
  return (dispatch) => {
    dispatch(requestFlavorsData());
    API.get(`/colour`).then((res) => {
      let getData = res.data;
      dispatch(successFlavorsGetData(getData));
    }).catch((error) => {
      dispatch(errorFlavorsGetData());
    });
  };
};


export const requestAddColour = () => {
  return {
    type: "REQUEST_ADD_COLOUR",
  };
};
export const successAddColour = (data) => {
  return {
    type: "SUCCESS_ADD_COLOUR",
    payload: data,
  };
};
export const errorAddColour = () => {
  return {
    type: "ERROR_ADD_COLOUR",
  };
};
export const AddColourApi = (data, showSuccessAlert, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestAddColour());
    API.post(`/colour`, data)
      .then((res) => {
        dispatch(successAddColour(data));
        showSuccessAlert(res.data.message);
      }).catch((error) => {
        dispatch(errorAddColour());
        showErrorAlert(error.response.data.message || "Something went wrong");
      });
  };
};


export const DeleteRequestColour = () => {
  return {
    type: "DELETE_REQUEST_COLOUR",
  };
};
export const DeleteSuccessColour = (user_id) => {
  return {
    type: "DELETE_SUCCESS_COLOUR",
    user_id: user_id,
  };
};
export const DeleteErrorColour = () => {
  return {
    type: "DELETE_ERROR_COLOUR",
  };
};
export const DeleteColourApi = (vendorId) => {
  return (dispatch) => {
    dispatch(DeleteRequestColour());
    API.delete(`/colour/${vendorId}`)
      .then((res) => {
        dispatch(getFlavorsData());
        dispatch(DeleteSuccessColour(vendorId));
      }).catch((error) => {
        dispatch(DeleteErrorColour());
      });
  };
};


export const UpdateRequestColour = () => {
  return {
    type: "UPDATE_REQUEST_COLOUR",
  };
};
export const UpdateSuccessColour = (data) => {
  return {
    type: "UPDATE_SUCCESS_COLOUR",
    payload: data,
  };
};
export const UpdateErrorColour = () => {
  return {
    type: "UPDATE_ERROR_COLOUR",
  };
};
export const UpdateColourApi = (data, oldData) => {
  return (dispatch) => {
    dispatch(UpdateRequestColour());
    API.put(`/colour/${oldData._id}`, {
      colourName: data.colourName,
      colourDesc: data.colourDesc,
    },
      {}
    ).then((res) => {
      dispatch(getFlavorsData());
      dispatch(UpdateSuccessColour([data]));
    }).catch((error) => {
      dispatch(UpdateErrorColour())
    });
  };
};
